module.exports = __webpack_public_path__ + "img/selected1-min.3b2d754d.png";